@if (imagesCount > 0 || uploadProgress) {
  <div class="content">
    <div class="gallery-buttons">
      <div class="toggle-used-images" (click)="toggleUsedImages()">
        <mat-icon [svgIcon]="showUsedImages ? 'eye-close' : 'eye-open'">
        </mat-icon>
        <span>
          {{ showUsedImages
            ? ('i18n.toggle.hideUsedImages' | translate)
            : ('i18n.toggle.showUsedImages' | translate) }}
        </span>
      </div>
      <button class="primary"
        (click)="onUploadClick(imageSelect, true)">
        <mat-icon svgIcon="photo-upload"></mat-icon>
        <span class="upload-label">
          {{ 'i18n.button.uploadPhotos' | translate }}
        </span>
      </button>
      <input imageUpload #imageSelect id="image-select" type="file"
        multiple accept="image/*"/>
    </div>
    @if (galleryImages.length === 0 && !uploadProgress) {
      <div class="info">
        <div class="icon">
          <img [src]="allPhotosArePlacedUrl"/>
        </div>
        <h4 class="title" translate>
          i18n.gallery.placedAllPhotos.title
        </h4>
        <div class="content-message" translate>
          i18n.gallery.placedAllPhotos.message
        </div>
      </div>
    }
    <div class="wrapper">
      <div class="thumbnails" #thumbnailsWrapper>
        @for (image of galleryImages; track image.id) {
          <div class="thumbnail-container"
            [ngClass]="{'used': imageIsUsed(image.id),
                        'selected': imageIsSelected(image.id),
                        'load': image.isLoaded,
                        'loaded': !image.isLoaded }">
            @if (!image.isLoaded) {
              <div class="thumbnail-sceleton">
                <div class="spinner-wrapper">
                  <div #spinner class="spinner">
                    <mat-spinner diameter="48" class="img-spinner"></mat-spinner>
                  </div>
                </div>
              </div>
            }
            <img #imgElement class="thumbnail" draggable=true
              (load)="onLoad(image, imgElement)"
              [attr.data-imageId]="image.id"
              [attr.src]="getThumbnailUrl(image)"
              (dragstart)="dragStart(image.id)"
              (click)="imageIsClicked(image.id)"
            />
            <button class="delete-btn" (click)="removeImage(image.id)">
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
            @if (imageIsUsed(image.id)) {
              <div class="checkmark">
                <img [src]="checkmarkUrl"/>
              </div>
            }
          </div>
        }

        @if (remainingImageUploads > 0) {
          <div *repeat="remainingImageUploads">
            <div class="thumbnail-container">
              <div class="thumbnail-sceleton">
                <div class="spinner-wrapper">
                  <div #spinner class="spinner">
                    <mat-spinner diameter="48" class="img-spinner"></mat-spinner>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="info">
    <div class="icon">
      <img class="no-uploaded-photos" [src]="noUploadedPhotosUrl"/>
    </div>
    <h4 class="title" translate>
      i18n.gallery.uploadPhotos.title
    </h4>
    <div class="content-message" translate>
      i18n.gallery.uploadPhotos.message
    </div>
    <button class="primary upload-button"
      (click)="onUploadClick(imageSelect)">
      <mat-icon svgIcon="photo-upload"></mat-icon>
      <span>{{ 'i18n.button.uploadPhotos' | translate }}</span>
    </button>
    <div class="button image-select">
      <input imageUpload #imageSelect id="image-select" type="file"
        multiple accept="image/*"/>
    </div>
  </div>
}
